/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import styles from './TopicHero.module.scss';

import { HubHero } from '../../molecules/HubHero/HubHero';
import type { TopicHeroProps } from './TopicHero.types';

const WORDS_PER_MINUTE = 200;

export const TopicHero = ({ topic, groupTitle, breadcrumb, className }: TopicHeroProps) => {
  const { t } = useInt();

  const minutes = Math.max(1, Math.ceil(topic.article_word_count / WORDS_PER_MINUTE));

  return (
    <HubHero breadcrumb={breadcrumb} title={topic.h1 || topic.name} className={className}>
      <ul className={styles['meta']}>
        <li className={styles['chip']}>{groupTitle}</li>

        <li className={styles['chip']}>{topic.subgroup_name}</li>

        <li className={styles['read']}>{t('{minutes} min read').replace('{minutes}', String(minutes))}</li>
      </ul>
    </HubHero>
  );
};
